import storeDateSelectorResolve from "../../directive/store-date-selector/store-date-selector.resolve";
import reviewsResolve from "./reviews.resolve";

export default function routes($stateProvider) {
	$stateProvider.state("reviewsPage", {
		url: "/reviews/:stores?startDate&endDate&reviewsOffset&commentsFilter&ratingFilter&npsFilter",
		template: require("./reviews.html"),
		resolve: {
			...storeDateSelectorResolve,
			...reviewsResolve,
			brand: [
				"Brand",
				function(Brand) {
					return Brand.get();
				}
			],
			reviewsLoader: [
				"Review",
				"selectedStore",
				"endDate",
				"startDate",
				"reviewsOffset",
				"commentsFilter",
				"ratingFilter",
				"npsFilter",
				function(Review, selectedStore, endDate, startDate, reviewsOffset, commentsFilter, ratingFilter, npsFilter) {
					return _ =>
						Review.all({
							stores: JSON.stringify(selectedStore.storeIds),
							startDate,
							endDate,
							offset: reviewsOffset,
							comments: commentsFilter,
							rating: ratingFilter,
							nps: npsFilter
						});
				}
			],
			reviews: [
				"reviewsLoader",
				function(reviewsLoader) {
					return reviewsLoader();
				}
			],
			ratingStats: [
				"Rating",
				"selectedStore",
				"endDate",
				"startDate",
				function(Rating, selectedStore, endDate, startDate) {
					return Rating.getStats({
							stores: JSON.stringify(selectedStore.storeIds),
							startDate,
							endDate
						});
				}
			],
			npsstats: [
				"Nps",
				"selectedStore",
				"endDate",
				"startDate",
				function(Nps, selectedStore, endDate, startDate) {
					return Nps.getStats({
						stores: JSON.stringify(selectedStore.storeIds),
						startDate,
						endDate
					});
				}
			]
		},
		controller: "ReviewsController",
		controllerAs: "reviews"
	});
}

routes.$inject = ["$stateProvider"];



// WEBPACK FOOTER //
// ./src/page/reviews/reviews.routes.js